module.exports = __webpack_public_path__ + "static/media/yaseen-overseas.ec73f198.png";